import { APICall } from "@/config/NetworkUtility";

import { MODULE_DELETE, MODULES_LIST, MODULES_PAGINATION } from "./constant";

import { callLoader } from "@/redux/Loader/actions";
import { logApiError } from "@/services/apiErrorLogger";
import { MODULE_INSERT } from "./constant";
import { MODULE_UPDATE } from "./constant";

// ======================================
// GET MODULES
// ======================================

export const getModules = (payload) => async (dispatch) => {
  try {
    dispatch(callLoader(true));

    const queryParams = new URLSearchParams({
      ...payload,
    }).toString();

    const url = `v1/ModuleSetup/GetModuleList?${queryParams}`;

    const result = await APICall("get", payload, url);

    if (result?.statuscode === 200 || result?.statuscode === 201) {
      dispatch({
        type: MODULES_LIST,
        payload: result?.data || [],
      });

      dispatch({
        type: MODULES_PAGINATION,
        payload: result?.pagination || {},
      });

      return result?.data || [];
    }

    return Promise.reject(result);
  } catch (error) {
    logApiError(error, {
      source: "modules",
      endpoint: "GetModuleList",
      payload,
    });

    return Promise.reject(error);
  } finally {
    dispatch(callLoader(false));
  }
};

// ======================================
// GET MODULES DROPDOWN
// ======================================

export const getModuleDropdownList = (BASEMODULE_ID) => async (dispatch) => {
  try {
    dispatch(callLoader(true));

    const url = `v1/ModuleSetup/GetModuleDropdownList?BASEMODULE_ID=${BASEMODULE_ID}`;

    const result = await APICall("get", null, url);

    if (result?.statuscode === 200 || result?.statuscode === 201) {
      return result?.data || [];
    }

    return Promise.reject(result);
  } catch (error) {
    logApiError(error, {
      source: "getModuleDropdownList",
      endpoint: "GetModuleDropdownList",
      payload: { BASEMODULE_ID },
    });

    return Promise.reject(error);
  } finally {
    dispatch(callLoader(false));
  }
};

// ======================================
// INSERT
// ======================================

export const insertModule = (payload) => async (dispatch) => {
  try {
    dispatch(callLoader(true));

    const url = `v1/ModuleSetup/ModuleInsert`;

    const result = await APICall("post", payload, url, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (result?.statuscode === 200 || result?.statuscode === 201) {
      dispatch({
        type: MODULE_INSERT,
        payload: result?.data || result,
      });

      return result;
    }

    return Promise.reject(result);
  } catch (error) {
    logApiError(error, {
      source: "insertModule",
      endpoint: "v1/ModuleSetup/ModuleInsert",
      payload: "[FormData]",
    });

    return Promise.reject(error);
  } finally {
    dispatch(callLoader(false));
  }
};

// ======================================
// UPDATE
// ======================================

export const updateModule = (payload) => async (dispatch) => {
  try {
    dispatch(callLoader(true));

    const url = `v1/ModuleSetup/ModuleUpdate`;

    const result = await APICall("post", payload, url, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (result?.statuscode === 200 || result?.statuscode === 201) {
      dispatch({
        type: MODULE_UPDATE,
        payload: result?.data || result,
      });

      return result;
    }

    return Promise.reject(result);
  } catch (error) {
    logApiError(error, {
      source: "updateModule",
      endpoint: "v1/ModuleSetup/ModuleUpdate",
      payload: "[FormData]",
    });
      
      

    return Promise.reject(error);
  } finally {
    dispatch(callLoader(false));
  }
};


    // ======================================
    // DELETE
    // ======================================
    
    export const deleteModule = (payload) => async (dispatch) => {
      try {
        dispatch(callLoader(true));
    
        const url = `v1/ModuleSetup/DeleteModule`;
    
        const result = await APICall("post", payload, url, {
          headers: {
            accept: "*/*",
            "Content-Type": "application/json",
          },
        });
    
        if (result?.statuscode === 200 || result?.statuscode === 201) {
          dispatch({
            type: MODULE_DELETE,
            payload: payload?.MODULE_ID,
          });
    
          return result;
        }
    
        return Promise.reject(result);
      } catch (error) {
        logApiError(error, {
          source: "deleteModule",
          endpoint: "DeleteModule",
          payload,
        });
    
        return Promise.reject(error);
      } finally {
        dispatch(callLoader(false));
      }
    };